import { Form, FormContext, Flex } from 'dash-ui';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';
import { useGetOrganizationsForSelectQuery } from 'gql/generated.graphql';

const OrganizationSelect = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, formState, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const { data: result, loading } = useGetOrganizationsForSelectQuery({
    variables: { pagination: { allowLimit: false } },
  });
  const { data } = useMemo(
    () => ({
      data: result?.getOrganizations?.collection || [],
    }),
    [result]
  );

  const handleSelectInputs =
    (fieldName: FormFields) => (value: string, values?: string[]) => {
      stateHandlers[fieldName](values || value);
      valid(fieldName, values || value);
    };

  return (
    <Flex flexDirection="column" mr={2} flex={1} overflow="hidden">
      <Form.Label>{t('forms:labels.additionalOrganizations')}</Form.Label>
      <Form.Select
        isMulti
        menuPortalZIndex="auto"
        isLoading={loading}
        value={formState[FormFields.Organizations]}
        options={data
          .filter(
            (item) => item._id !== formState[FormFields.PrimaryOrganization]
          )
          .map((item) => ({
            value: item._id,
            label: item.name,
          }))}
        placeholder={t('forms:placeholders.selectOne')}
        w="100%"
        onChanged={handleSelectInputs(FormFields.Organizations)}
        $errorType={formErrors[FormFields.Organizations]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Organizations]?.type}>
        {formErrors[FormFields.Organizations]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default OrganizationSelect;
